import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell } from "../../components/layout";
import InsightReportJobsPage from "./ui";

const InsightReportJobs = () => (
  <DashboardLayout>
    <DashboardNavbar />
    <PageContentShell>
      <InsightReportJobsPage />
    </PageContentShell>
  </DashboardLayout>
);

export default InsightReportJobs;
